import { CodeBase } from "./_codeBase";

/** 実行区分*/
export class ExecuteDiv extends CodeBase<ExecuteDiv>
{

    /** 実行区分: "0", "待機中"*/
    public static readonly WAIT: ExecuteDiv = new ExecuteDiv("0", "待機中", "");
    /** 実行区分: "1", "実行中"*/
    public static readonly RUNNING: ExecuteDiv = new ExecuteDiv("1", "実行中", "");
    /** 実行区分: "2", "予約済"*/
    public static readonly RESERVED: ExecuteDiv = new ExecuteDiv("2", "予約済", "");
    /** 実行区分: "3", "正常終了"*/
    public static readonly SUCCESS: ExecuteDiv = new ExecuteDiv("3", "正常終了", "");
    /** 実行区分: "4", "異常終了"*/
    public static readonly ERROR: ExecuteDiv = new ExecuteDiv("4", "異常終了", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ExecuteDiv[] {
        return [
            ExecuteDiv.WAIT,
            ExecuteDiv.RUNNING,
            ExecuteDiv.RESERVED,
            ExecuteDiv.SUCCESS,
            ExecuteDiv.ERROR
        ];
    }
}
